<div id="email-container">
  <p class="subheading-01-semi-bold">
    Se enviará por email
    <strong>1</strong> factura emitida.
  </p>
  <mat-checkbox
    [checked]="this.emailCheck"
    color="primary"
    id="check"
    (change)="checkboxChange($event.checked)"
  >
    <p class="subheading-01-semi-bold">¿Desea recibir una copia por email?</p>
  </mat-checkbox>
</div>
